module.exports = __webpack_public_path__ + "static/img/6.9b3715f.png";


//////////////////
// WEBPACK FOOTER
// ./static/honour/6.png
// module id = bWvi
// module chunks = 1